import React from "react"
import { useNavigate } from 'react-router-dom'

const btnBase = "h-10 w-24 sm:h-12 sm:w-36 border-0 rounded-md bg-bankroll-primary text-white text-sm sm:text-xl font-karla cursor-pointer focus:outline-none active:shadow-inner"

const h2 = { fontSize: '1.35rem', fontWeight: 700, marginTop: '2rem', marginBottom: '0.5rem', paddingBottom: '0.3rem', borderBottom: '1px solid #ece8d8', color: '#1d1d1d' }
const h3 = { fontSize: '1.1rem', fontWeight: 700, marginTop: '1.4rem', marginBottom: '0.35rem', color: '#333' }
const p = { margin: '0 0 0.85rem' }
const ul = { margin: '0 0 0.85rem', paddingLeft: '1.4rem' }
const li = { marginBottom: '0.35rem' }

const catLabel = { color: '#b03a2e', fontWeight: 700 }
const noteBox = { fontSize: '0.92rem', color: '#555', background: '#fcf8ec', borderLeft: '4px solid #d9b85a', padding: '0.65rem 1rem', margin: '1rem 0', borderRadius: '0 4px 4px 0' }
const anatomyBox = { background: '#f3f6f2', padding: '1rem 1.25rem', borderRadius: 6, margin: '1.25rem 0', borderLeft: '4px solid #6a9c78' }

// cheat-sheet table styles
const tbl = { gridTemplateColumns: 'minmax(75px, 1fr) 52px repeat(7, 36px) 46px', borderCollapse: 'collapse', width: '100%', minWidth: 480, fontSize: '0.88rem', background: '#fff' }
const th = { border: '1px solid #333', padding: '0.3rem 0.2rem', textAlign: 'center', verticalAlign: 'middle', background: '#efeada', fontWeight: 600, color: '#1d1d1d', fontSize: '0.72rem' }
const tdBase = { border: '1px solid #333', padding: '0.3rem 0.2rem', textAlign: 'center', verticalAlign: 'middle' }
const tdCat = { ...tdBase, textAlign: 'left', fontWeight: 600, whiteSpace: 'nowrap', background: '#faf8ef' }
const tdRed = { ...tdBase, background: '#f5b1a8' }
const tdScore = { ...tdBase, fontWeight: 700, fontSize: '0.95rem' }
const tdInvalid = { ...tdBase, background: '#f1f1f1', color: '#666' }
const tdInvalidRed = { ...tdBase, background: '#f5b1a8' }
const tdInvalidCat = { ...tdCat, background: '#f1f1f1', color: '#666', fontStyle: 'italic' }
const tdInvalidScore = { ...tdScore, color: '#b03a2e', background: '#f1f1f1' }

function Die({ face, red = false, invalid = false }) {
    const color = red
        ? (invalid ? '#d9c4c1' : '#f5b1a8')
        : (invalid ? '#f7f5f0' : '#ffffff')
    return (
        <svg style={{ width: 26, height: 26, display: 'inline-block', verticalAlign: 'middle', color }} viewBox="0 0 60 60">
            <use href={`#die-${face}`} />
        </svg>
    )
}

export default function Rules() {
    const navigate = useNavigate()

    return (
        <main className="bg-bankroll-surface h-screen max-w-full p-[5px] flex flex-col justify-around items-center sm:h-[600px]">
            <h1 className="text-2xl sm:text-4xl p-2 m-0 font-bold">Rules</h1>

            <div className="h-[450px] overflow-y-scroll p-[10px] max-w-[670px] w-full">

                {/* Reusable dice SVG symbols */}
                <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true">
                    <defs>
                        <symbol id="die-1" viewBox="0 0 60 60">
                            <rect x="3" y="3" width="54" height="54" rx="9" ry="9" fill="currentColor" stroke="#333" strokeWidth="2.5" />
                            <circle cx="30" cy="30" r="4.5" fill="#222" />
                        </symbol>
                        <symbol id="die-2" viewBox="0 0 60 60">
                            <rect x="3" y="3" width="54" height="54" rx="9" ry="9" fill="currentColor" stroke="#333" strokeWidth="2.5" />
                            <circle cx="19" cy="19" r="4.5" fill="#222" />
                            <circle cx="41" cy="41" r="4.5" fill="#222" />
                        </symbol>
                        <symbol id="die-3" viewBox="0 0 60 60">
                            <rect x="3" y="3" width="54" height="54" rx="9" ry="9" fill="currentColor" stroke="#333" strokeWidth="2.5" />
                            <circle cx="18" cy="18" r="4.5" fill="#222" />
                            <circle cx="30" cy="30" r="4.5" fill="#222" />
                            <circle cx="42" cy="42" r="4.5" fill="#222" />
                        </symbol>
                        <symbol id="die-4" viewBox="0 0 60 60">
                            <rect x="3" y="3" width="54" height="54" rx="9" ry="9" fill="currentColor" stroke="#333" strokeWidth="2.5" />
                            <circle cx="19" cy="19" r="4.5" fill="#222" />
                            <circle cx="41" cy="19" r="4.5" fill="#222" />
                            <circle cx="19" cy="41" r="4.5" fill="#222" />
                            <circle cx="41" cy="41" r="4.5" fill="#222" />
                        </symbol>
                        <symbol id="die-5" viewBox="0 0 60 60">
                            <rect x="3" y="3" width="54" height="54" rx="9" ry="9" fill="currentColor" stroke="#333" strokeWidth="2.5" />
                            <circle cx="19" cy="19" r="4.5" fill="#222" />
                            <circle cx="41" cy="19" r="4.5" fill="#222" />
                            <circle cx="30" cy="30" r="4.5" fill="#222" />
                            <circle cx="19" cy="41" r="4.5" fill="#222" />
                            <circle cx="41" cy="41" r="4.5" fill="#222" />
                        </symbol>
                        <symbol id="die-6" viewBox="0 0 60 60">
                            <rect x="3" y="3" width="54" height="54" rx="9" ry="9" fill="currentColor" stroke="#333" strokeWidth="2.5" />
                            <circle cx="19" cy="16" r="4.5" fill="#222" />
                            <circle cx="41" cy="16" r="4.5" fill="#222" />
                            <circle cx="19" cy="30" r="4.5" fill="#222" />
                            <circle cx="41" cy="30" r="4.5" fill="#222" />
                            <circle cx="19" cy="44" r="4.5" fill="#222" />
                            <circle cx="41" cy="44" r="4.5" fill="#222" />
                        </symbol>
                    </defs>
                </svg>

                <p style={p}>
                    Bank Roll is a dice game played with 7 dice &mdash; 6 white and 1 colored. The game consists of 13 rounds.
                    The object is to score the highest total by completing the 13 scoring categories described below.
                </p>

                <h2 style={h2}>Number of Players</h2>
                <p style={p}>One to six players.</p>

                <h2 style={h2}>How a Turn Works</h2>
                <p style={p}>
                    A turn typically consists of 3 rolls. To start, the player picks up all 7 dice and rolls them. They may then
                    re-roll some or all of the dice up to two more times, setting aside any dice they want to keep between rolls.
                    A player may change strategy mid-turn and re-roll dice they previously set aside.
                </p>
                <p style={p}>A turn ends when either:</p>
                <ol style={{ ...ul, listStyleType: 'decimal' }}>
                    <li style={li}>The player has used all 3 rolls (unless extending the turn with banked rolls &mdash; see below), or</li>
                    <li style={li}>The player has completed a category and chooses to stop.</li>
                </ol>
                <p style={p}>
                    Each of the 13 categories can be used only once per game, but there is no required order &mdash; the player
                    chooses which open category to score at the end of each turn.
                </p>
                <p style={p}>
                    The player may not pass. They must enter a score in one of the 13 categories at the end of every turn, even
                    if that score is zero. Once a category has been filled, its score cannot be changed.
                </p>

                <h3 style={h3}>The Red Die Rule</h3>
                <p style={p}>
                    Every scored category &mdash; <em>except Spare Change</em> &mdash; requires the red die to be part of the
                    scoring combination. For example, if a player rolls three sixes on the white dice but the red die shows a
                    different value, the roll cannot be scored as 3 of a Kind. In that case the only options are to score Spare
                    Change (if still open) or to take a zero in any open category.
                </p>
                <p style={p}>See the Cheat Sheet below for a visual example of every category, including a non-scoring example that illustrates this rule.</p>

                <h3 style={h3}>Banking Extra Rolls</h3>
                <p style={p}>
                    If a player completes a category in fewer than 3 rolls, any unused rolls can be banked for later use.
                </p>
                <p style={p}>
                    A player may also bank 3 rolls without rolling at all on a given turn &mdash; by choosing not to roll,
                    entering a zero in any open category, and keeping all 3 rolls in the bank.
                </p>
                <p style={p}>
                    On a future turn, after using their 3 regular rolls, a player may extend the turn by spending banked rolls.
                    A player may use as many banked rolls in a single turn as they have available. For example, a player who
                    begins a turn with 8 banked rolls could roll up to 11 times in that turn: 3 regular rolls plus 8 banked
                    rolls. Banked rolls used during a turn are deducted from the bank.
                </p>
                <p style={p}>
                    Banked rolls can be spent either to complete a category that wasn&apos;t finished in the regular 3 rolls,
                    or to keep rolling for a better result. A player may also switch target categories while using banked rolls,
                    just as in regular play.
                </p>

                <h2 style={h2}>Fixed Point Categories</h2>
                <p style={p}>
                    Most fixed point categories are worth <strong>30 points</strong> and require 6 of the 7 dice. The exception
                    is 7 of a Kind, which uses all 7 dice and is worth <strong>75 points</strong>.
                </p>
                <ul style={ul}>
                    <li style={li}><span style={catLabel}>3 Pairs</span> &mdash; three pairs of matching dice. A 4 of a kind plus a pair also qualifies, since the four-of-a-kind counts as two pairs.</li>
                    <li style={li}><span style={catLabel}>2 Triples</span> &mdash; two sets of three matching dice.</li>
                    <li style={li}><span style={catLabel}>Evens</span> &mdash; six dice showing even face values (2, 4, 6).</li>
                    <li style={li}><span style={catLabel}>Odds</span> &mdash; six dice showing odd face values (1, 3, 5).</li>
                    <li style={li}><span style={catLabel}>Lows</span> &mdash; six dice showing low face values (1, 2, 3).</li>
                    <li style={li}><span style={catLabel}>Highs</span> &mdash; six dice showing high face values (4, 5, 6).</li>
                    <li style={li}><span style={catLabel}>Straight</span> &mdash; six dice showing 1, 2, 3, 4, 5, and 6 (one of each).</li>
                    <li style={li}><span style={catLabel}>7 of a Kind</span> &mdash; all seven dice showing the same face value. Worth 75 points.</li>
                </ul>

                <h2 style={h2}>Variable Point Categories</h2>
                <p style={p}>
                    Variable point categories are scored by adding the face values of the scoring dice. For example, three sixes
                    scored as 3 of a Kind earns 18 points (3 &times; 6); the remaining dice are not counted. For Spare Change,
                    all seven dice are counted.
                </p>
                <ul style={ul}>
                    <li style={li}><span style={catLabel}>3 of a Kind</span> &mdash; three dice of the same face value. Score equals the sum of those three dice.</li>
                    <li style={li}><span style={catLabel}>4 of a Kind</span> &mdash; four dice of the same face value. Score equals the sum of those four dice.</li>
                    <li style={li}><span style={catLabel}>5 of a Kind</span> &mdash; five dice of the same face value. Score equals the sum of those five dice.</li>
                    <li style={li}><span style={catLabel}>6 of a Kind</span> &mdash; six dice of the same face value. Score equals the sum of those six dice.</li>
                    <li style={li}><span style={catLabel}>Spare Change</span> &mdash; the sum of the face values of all seven dice. The red die does not need to be part of any specific combination; it is included automatically since all 7 dice are counted.</li>
                </ul>

                <h2 style={h2}>Cheat Sheet</h2>
                <p style={p}>Each row shows a sample scoring roll for a category. The red die &mdash; shown with a pink background &mdash; must be part of the scoring combination for every category except Spare Change.</p>

                <div style={{ overflowX: 'auto', margin: '1rem 0 1.25rem', WebkitOverflowScrolling: 'touch' }}>
                    <table style={tbl}>
                        <thead>
                            <tr>
                                <th style={th}>Category</th>
                                <th style={th}>Value</th>
                                <th style={th}>Die 1</th>
                                <th style={th}>Die 2</th>
                                <th style={th}>Die 3</th>
                                <th style={th}>Die 4</th>
                                <th style={th}>Die 5</th>
                                <th style={th}>Die 6</th>
                                <th style={th}>Die 7</th>
                                <th style={th}>Score</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={tdCat}>3 Pairs</td>
                                <td style={tdBase}>30</td>
                                <td style={tdRed}><Die face={1} red /></td>
                                <td style={tdBase}><Die face={1} /></td>
                                <td style={tdBase}><Die face={4} /></td>
                                <td style={tdBase}><Die face={4} /></td>
                                <td style={tdBase}><Die face={5} /></td>
                                <td style={tdBase}><Die face={5} /></td>
                                <td style={tdBase}></td>
                                <td style={tdScore}>30</td>
                            </tr>
                            <tr>
                                <td style={tdCat}>2 Triples</td>
                                <td style={tdBase}>30</td>
                                <td style={tdRed}><Die face={2} red /></td>
                                <td style={tdBase}><Die face={2} /></td>
                                <td style={tdBase}><Die face={2} /></td>
                                <td style={tdBase}><Die face={1} /></td>
                                <td style={tdBase}><Die face={1} /></td>
                                <td style={tdBase}><Die face={1} /></td>
                                <td style={tdBase}></td>
                                <td style={tdScore}>30</td>
                            </tr>
                            <tr>
                                <td style={tdCat}>Evens</td>
                                <td style={tdBase}>30</td>
                                <td style={tdRed}><Die face={6} red /></td>
                                <td style={tdBase}><Die face={2} /></td>
                                <td style={tdBase}><Die face={4} /></td>
                                <td style={tdBase}><Die face={4} /></td>
                                <td style={tdBase}><Die face={2} /></td>
                                <td style={tdBase}><Die face={2} /></td>
                                <td style={tdBase}></td>
                                <td style={tdScore}>30</td>
                            </tr>
                            <tr>
                                <td style={tdCat}>Odds</td>
                                <td style={tdBase}>30</td>
                                <td style={tdRed}><Die face={5} red /></td>
                                <td style={tdBase}><Die face={3} /></td>
                                <td style={tdBase}><Die face={5} /></td>
                                <td style={tdBase}><Die face={5} /></td>
                                <td style={tdBase}><Die face={5} /></td>
                                <td style={tdBase}><Die face={1} /></td>
                                <td style={tdBase}></td>
                                <td style={tdScore}>30</td>
                            </tr>
                            <tr>
                                <td style={tdCat}>Lows</td>
                                <td style={tdBase}>30</td>
                                <td style={tdRed}><Die face={1} red /></td>
                                <td style={tdBase}><Die face={2} /></td>
                                <td style={tdBase}><Die face={3} /></td>
                                <td style={tdBase}><Die face={3} /></td>
                                <td style={tdBase}><Die face={3} /></td>
                                <td style={tdBase}><Die face={1} /></td>
                                <td style={tdBase}></td>
                                <td style={tdScore}>30</td>
                            </tr>
                            <tr>
                                <td style={tdCat}>Highs</td>
                                <td style={tdBase}>30</td>
                                <td style={tdRed}><Die face={5} red /></td>
                                <td style={tdBase}><Die face={5} /></td>
                                <td style={tdBase}><Die face={5} /></td>
                                <td style={tdBase}><Die face={6} /></td>
                                <td style={tdBase}><Die face={6} /></td>
                                <td style={tdBase}><Die face={5} /></td>
                                <td style={tdBase}></td>
                                <td style={tdScore}>30</td>
                            </tr>
                            <tr>
                                <td style={tdCat}>Straight</td>
                                <td style={tdBase}>30</td>
                                <td style={tdRed}><Die face={1} red /></td>
                                <td style={tdBase}><Die face={2} /></td>
                                <td style={tdBase}><Die face={3} /></td>
                                <td style={tdBase}><Die face={4} /></td>
                                <td style={tdBase}><Die face={5} /></td>
                                <td style={tdBase}><Die face={6} /></td>
                                <td style={tdBase}></td>
                                <td style={tdScore}>30</td>
                            </tr>
                            <tr>
                                <td style={tdCat}>3 of a Kind</td>
                                <td style={tdBase}>Sum</td>
                                <td style={tdRed}><Die face={6} red /></td>
                                <td style={tdBase}><Die face={6} /></td>
                                <td style={tdBase}><Die face={6} /></td>
                                <td style={tdBase}></td>
                                <td style={tdBase}></td>
                                <td style={tdBase}></td>
                                <td style={tdBase}></td>
                                <td style={tdScore}>18</td>
                            </tr>
                            <tr>
                                <td style={tdCat}>4 of a Kind</td>
                                <td style={tdBase}>Sum</td>
                                <td style={tdRed}><Die face={3} red /></td>
                                <td style={tdBase}><Die face={3} /></td>
                                <td style={tdBase}><Die face={3} /></td>
                                <td style={tdBase}><Die face={3} /></td>
                                <td style={tdBase}></td>
                                <td style={tdBase}></td>
                                <td style={tdBase}></td>
                                <td style={tdScore}>12</td>
                            </tr>
                            <tr>
                                <td style={tdCat}>5 of a Kind</td>
                                <td style={tdBase}>Sum</td>
                                <td style={tdRed}><Die face={2} red /></td>
                                <td style={tdBase}><Die face={2} /></td>
                                <td style={tdBase}><Die face={2} /></td>
                                <td style={tdBase}><Die face={2} /></td>
                                <td style={tdBase}><Die face={2} /></td>
                                <td style={tdBase}></td>
                                <td style={tdBase}></td>
                                <td style={tdScore}>10</td>
                            </tr>
                            <tr>
                                <td style={tdCat}>6 of a Kind</td>
                                <td style={tdBase}>Sum</td>
                                <td style={tdRed}><Die face={5} red /></td>
                                <td style={tdBase}><Die face={5} /></td>
                                <td style={tdBase}><Die face={5} /></td>
                                <td style={tdBase}><Die face={5} /></td>
                                <td style={tdBase}><Die face={5} /></td>
                                <td style={tdBase}><Die face={5} /></td>
                                <td style={tdBase}></td>
                                <td style={tdScore}>30</td>
                            </tr>
                            <tr>
                                <td style={tdCat}>7 of a Kind</td>
                                <td style={tdBase}>75</td>
                                <td style={tdRed}><Die face={1} red /></td>
                                <td style={tdBase}><Die face={1} /></td>
                                <td style={tdBase}><Die face={1} /></td>
                                <td style={tdBase}><Die face={1} /></td>
                                <td style={tdBase}><Die face={1} /></td>
                                <td style={tdBase}><Die face={1} /></td>
                                <td style={tdBase}><Die face={1} /></td>
                                <td style={tdScore}>75</td>
                            </tr>
                            <tr>
                                <td style={tdCat}>Spare Change</td>
                                <td style={tdBase}>Sum</td>
                                <td style={tdRed}><Die face={4} red /></td>
                                <td style={tdBase}><Die face={5} /></td>
                                <td style={tdBase}><Die face={5} /></td>
                                <td style={tdBase}><Die face={5} /></td>
                                <td style={tdBase}><Die face={3} /></td>
                                <td style={tdBase}><Die face={3} /></td>
                                <td style={tdBase}><Die face={4} /></td>
                                <td style={tdScore}>29</td>
                            </tr>
                            <tr>
                                <td style={tdInvalidCat}>3 of a Kind<br /><small>(non-scoring)</small></td>
                                <td style={tdInvalid}>&mdash;</td>
                                <td style={tdInvalidRed}><Die face={2} red invalid /></td>
                                <td style={tdInvalid}><Die face={6} invalid /></td>
                                <td style={tdInvalid}><Die face={6} invalid /></td>
                                <td style={tdInvalid}><Die face={6} invalid /></td>
                                <td style={tdInvalid}></td>
                                <td style={tdInvalid}></td>
                                <td style={tdInvalid}></td>
                                <td style={tdInvalidScore}>0</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <p style={noteBox}>
                    <strong>Non-scoring example.</strong> The last row shows three sixes &mdash; but the red die landed on a 2,
                    so it is not part of the three-of-a-kind. This roll cannot score as 3 of a Kind. It can only be entered as
                    Spare Change (if still open), or as a zero in any open category.
                </p>

                <h3 style={h3}>Key</h3>
                <table style={{ gridTemplateColumns: '56px 1fr', borderCollapse: 'collapse', margin: '0.5rem 0', fontSize: '0.92rem' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '0.4rem 0.65rem', border: '1px solid #ccc', verticalAlign: 'middle', width: 56, textAlign: 'center' }}>
                                <Die face={3} />
                            </td>
                            <td style={{ padding: '0.4rem 0.65rem', border: '1px solid #ccc', verticalAlign: 'middle' }}>Die included in the scoring combination</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '0.4rem 0.65rem', border: '1px solid #ccc', verticalAlign: 'middle', width: 56, textAlign: 'center', background: '#f5b1a8' }}>
                                <Die face={3} red />
                            </td>
                            <td style={{ padding: '0.4rem 0.65rem', border: '1px solid #ccc', verticalAlign: 'middle' }}>Red die, must be part of scoring combination (except for Spare Change)</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '0.4rem 0.65rem', border: '1px solid #ccc', verticalAlign: 'middle', width: 56, textAlign: 'center' }}></td>
                            <td style={{ padding: '0.4rem 0.65rem', border: '1px solid #ccc', verticalAlign: 'middle' }}>Empty cell, die not counted in this category</td>
                        </tr>
                    </tbody>
                </table>

                <h2 style={h2}>Anatomy of a Turn</h2>
                <div style={anatomyBox}>
                    <p style={p}>A player rolls 2 ones (one of them the red die), two fours, one two, one six, and a three on the first roll.</p>

                    <div style={{ overflowX: 'auto', margin: '0.75rem 0' }}>
                        <table style={{ gridTemplateColumns: 'repeat(7, 40px)', borderCollapse: 'collapse' }}>
                            <tbody>
                                <tr>
                                    <td style={tdRed}><Die face={1} red /></td>
                                    <td style={tdBase}><Die face={1} /></td>
                                    <td style={tdBase}><Die face={4} /></td>
                                    <td style={tdBase}><Die face={4} /></td>
                                    <td style={tdBase}><Die face={2} /></td>
                                    <td style={tdBase}><Die face={6} /></td>
                                    <td style={tdBase}><Die face={3} /></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <p style={p}>Several scoring options that involve keeping the red die are open:</p>
                    <ul style={ul}>
                        <li style={li}>Keep 2 pairs and roll for 3 Pairs</li>
                        <li style={li}>Keep 2 pairs and roll for 2 Triples</li>
                        <li style={li}>Keep 4 low dice and roll for Lows</li>
                        <li style={li}>Keep 3 odd dice and roll for Odds</li>
                        <li style={li}>Keep 5 dice toward a Straight</li>
                        <li style={li}>Keep 2 ones and roll for 3, 4, 5, or 6 of a Kind</li>
                        <li style={li}>Keep all dice for Spare Change and bank 2 rolls</li>
                    </ul>

                    <p style={p}>For any other combination, the player would have to take the higher-risk option of re-rolling the red die.</p>
                    <p style={p}>In this example, the player chooses to keep two pairs and roll for 3 Pairs, re-rolling the two, the six, and the three.</p>

                    <div style={{ overflowX: 'auto', margin: '0.75rem 0' }}>
                        <table style={{ gridTemplateColumns: 'repeat(7, 40px)', borderCollapse: 'collapse' }}>
                            <tbody>
                                <tr>
                                    <td style={tdRed}><Die face={1} red /></td>
                                    <td style={tdBase}><Die face={1} /></td>
                                    <td style={tdBase}><Die face={4} /></td>
                                    <td style={tdBase}><Die face={4} /></td>
                                    <td style={tdBase}><Die face={5} /></td>
                                    <td style={tdBase}><Die face={5} /></td>
                                    <td style={tdBase}><Die face={2} /></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <p style={{ margin: 0 }}>On the second roll, the player rolls two fives and a two, completing the 3 Pairs category with one extra two left over. The player ends their turn, scoring 30 points and banking 1 roll.</p>
                </div>

                <h2 style={h2}>Winning</h2>
                <p style={p}>
                    The game ends after every player has taken 13 turns. Each player totals their score, and the player with the
                    highest total wins. If two or more players are tied for the highest score, they share the victory.
                </p>

            </div>

            <button className={btnBase} onClick={() => navigate("/")}>Game</button>
        </main>
    )
}
